import styled from 'styled-components';

const PopupBody = styled('div') `
	box-sizing: border-box;
	padding: 20px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 18px;
	line-height: 20px;
	text-align: center;
`;

export { PopupBody };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/NotificationPopup/styles.ts